export default {
  placesCarousel: {
    layer: 'Vrstva',
    lat: 'Lat.',
    lon: 'Lon.',
    notAvailable: 'Nedostupné',
    placeDetails: 'Detaily místa',
    next: 'Další blok',
    prev: 'Předchozí blok',
    directionsTo: 'Instrukce k',
    distance: 'Vzdálenost',
    distanceFromLocationMarkedOnTheMap: 'Přibližná vzdálenost od místa vyznačeného na mapě',
    selectPlace: 'Vybrat'
  }
}
